function unwrapItem(value: unknown): string {
  if (typeof value === 'object' && value !== null && 'value' in value) {
    return String(value.value);
  }
  return String(value);
}

export function unwrapMetadataValue(value: unknown): string {
  if (value === null || value === undefined) {
    return '';
  }
  if (Array.isArray(value)) {
    return value.map(unwrapItem).filter(Boolean).join(', ');
  }
  if (typeof value === 'object' && !('value' in value)) {
    return JSON.stringify(value);
  }
  return unwrapItem(value);
}
